import { render, staticRenderFns } from "./add-task-category-modal.vue?vue&type=template&id=5ea91608"
import script from "./add-task-category-modal.ts?vue&type=script&lang=ts&external"
export * from "./add-task-category-modal.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports